<template>
  <b-row>
    <b-col
      v-for="(counter,index) in counters"
      :key="index"
    >
      <statistic-card
        :icon="counter.icon"
        :color="counter.color"
        :toplam="counter.toplam"
        :zekat="counter.zekat"
        :sadaka="counter.sadaka"
        :statistic-title="counter.title"
        :details="counter.details"
      />
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import StatisticCard from '@/views/Admin/Account_activities/Components/Counters/StatisticCard.vue'

export default {
  name: 'Counters',
  components: {
    BRow, BCol, StatisticCard,
  },
  computed: {
    counters() {
      return this.$store.getters['accountActivities/countersData']
    },
  },
}
</script>
